export const ACCESS_TOKEN = 'E_A_T';
export const REFRESH_TOKEN = 'E_R_T';
export const ROLES = 'ROLES';
export const EVENT_NAME_AR = 'nameAr';
export const EVENT_NAME_EN = 'nameEn';
export const CREATORID = '904409b3-f6ab-48d4-b68e-0552a60eae03';
export const LIMIT = 12;
export const REG_URL = '^(https?://)[0-9a-zA-Z]+.[-_0-9a-zA-Z]+.[0-9a-zA-Z]+$';
export const DEFAULT_LANGUAGE = 'DEFAULT_LANGUAGE';
